module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAECAYAAAC+0w63AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA1SURBVBhXYxQpuTKdgYEhA4iJBv///9/BBKRJ0gQCjIyMHiCNZAGm/wwMW6BsosH///8vAABkrwxLmrZODgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minus.png
// module id = 546
// module chunks = 1